import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import { IncludeQuestionsHandler } from './include-questions-handler';
import QuestionInteractionComponent from './question-interaction-component.vue'
import { QuestionInteractionStateProtobufSerializer } from './question-interaction-state-protobuf-serializer';
import { QuestionInteractionStateChooserPlugin } from './question-interaction-state-chooser-plugin'
import { QuestionInteractionState } from './question-interaction-state';

export const questionFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(QuestionInteractionComponent)
    .whenTargetNamed("question");

  bind<Api.InteractionStateChooserPlugin<QuestionInteractionState>>(Api.InteractionStateChooserPluginSymbol)
    .toConstantValue(new QuestionInteractionStateChooserPlugin())
    .whenTargetNamed('question')
  
  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeQuestionsHandler);

  bind(SerializationApi.StateSerializationPluginSymbol).to(QuestionInteractionStateProtobufSerializer)
});
